import { render } from "./recent-rating-list.vue?vue&type=template&id=e576622a&scoped=true"
import script from "./recent-rating-list.vue?vue&type=script&lang=js"
export * from "./recent-rating-list.vue?vue&type=script&lang=js"

import "./recent-rating-list.vue?vue&type=style&index=0&id=e576622a&scoped=true&lang=scss"

import exportComponent from "/tmp/build_ed238492/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e576622a"]])

export default __exports__